import { render, staticRenderFns } from "./MyRanches.vue?vue&type=template&id=17087d88&scoped=true&"
import script from "./MyRanches.vue?vue&type=script&lang=js&"
export * from "./MyRanches.vue?vue&type=script&lang=js&"
import style0 from "./MyRanches.vue?vue&type=style&index=0&id=17087d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17087d88",
  null
  
)

export default component.exports